import type { ParticipantItem } from "@/graphql";
import type { IMultiSelectItem } from "@/interfaces";

const toFullName = (item: ParticipantItem): string => {
  if (!item.name && !item.surname) {
    return item.displayName;
  }

  return [item.name || "", item.surname || ""].join(" ").trim();
};

const toMultiSelectItem = (item: ParticipantItem): IMultiSelectItem => {
  const result: IMultiSelectItem = {
    id: item.id,
    title: toFullName(item),
    imageURL: item.image?.source,
    blurhash: item.image?.blurhash,
  };

  if (item.__typename === "Employee" || item.__typename === "Resident") {
    const [department] = item.departments || [];
    if (department) {
      result.icon = "fas fa-home";
      result.iconBackground = department.color ?? undefined;
      result.tooltip = department.name;
    }
  }

  return result;
};

export default {
  toMultiSelectItem,
};
